import { accountBudgetsRouteProps } from 'src/navigation/routeProps'
import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import { createBackgroundReducer } from 'src/redux/genericReducers'

export interface AccountBudgetsState {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
}

export const initialState: AccountBudgetsState = {
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
}

export type Actions = CreditCardsFullPaginatedDataActions

const CoreAccountBudgetsReducer = (
  state = initialState,
  action: Actions,
): AccountBudgetsState => ({
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
})

const AccountBudgetsReducer = createBackgroundReducer(
  accountBudgetsRouteProps,
  initialState,
  CoreAccountBudgetsReducer,
)

export default AccountBudgetsReducer
